/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cake_Box_HistoryInputs */

const en_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cake box history`)
};

const ar_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل صناديق الكعك`)
};

const de_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuchenboxen-Verlauf`)
};

const es_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de cajas de pastel`)
};

const fr_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique des boîtes à gâteaux`)
};

const it_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronologia scatole di torte`)
};

const ja_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキボックスの履歴`)
};

const ko_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이크 상자 기록`)
};

const pt_br_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Histórico das caixas de bolo`)
};

const ru_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`История коробок с тортом`)
};

const th_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประวัติกล่องเค้ก`)
};

const tr_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta kutusu geçmişi`)
};

const zh_cn_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开盒记录`)
};

const zh_tw_cake_box_history = /** @type {(inputs: Cake_Box_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開盒紀錄`)
};

/**
* | output |
* | --- |
* | "Cake box history" |
*
* @param {Cake_Box_HistoryInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const cake_box_history = /** @type {((inputs?: Cake_Box_HistoryInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cake_Box_HistoryInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cake_box_history(inputs)
	if (locale === "ar") return ar_cake_box_history(inputs)
	if (locale === "de") return de_cake_box_history(inputs)
	if (locale === "es") return es_cake_box_history(inputs)
	if (locale === "fr") return fr_cake_box_history(inputs)
	if (locale === "it") return it_cake_box_history(inputs)
	if (locale === "ja") return ja_cake_box_history(inputs)
	if (locale === "ko") return ko_cake_box_history(inputs)
	if (locale === "pt_br") return pt_br_cake_box_history(inputs)
	if (locale === "ru") return ru_cake_box_history(inputs)
	if (locale === "th") return th_cake_box_history(inputs)
	if (locale === "tr") return tr_cake_box_history(inputs)
	if (locale === "zh_cn") return zh_cn_cake_box_history(inputs)
	return zh_tw_cake_box_history(inputs)
});